'use strict';

import angular from 'angular';

export default class MeContactCtrl {
  constructor(ToastrSvc, UserSvc) {
    var that = this;

    this.emailTypes = ['Personal', 'Work'];
    this.numberTypes = ['Mobile', 'Work', 'Home', 'Fax'];
    this.addressTypes = ['Home', 'Work'];

    this.edit = function(user) {
      that.user = user;
      that.model = angular.copy(user);

      // convert to object for angular forms
      // leaving as a string causes unusual ngModel behavior
      if(that.model.addresses) {
        that.model.addresses = that.model.addresses.map(function(a) {
          a.lines = a.lines.map(function(line) {
            return {line};
          });
          return a;
        });
      }

      that.showForm = true;
    };

    this.view = function() {
      if(that.user) { that.model = angular.copy(that.user); }
      that.showForm = false;
    };

    this.addEmail = function() {
      if(!that.model.emails) {
        that.model.emails = [];
      }
      that.model.emails.push({});
    };

    this.addNumber = function() {
      if(!that.model.numbers) {
        that.model.numbers = [];
      }
      that.model.numbers.push({});
    };

    this.addLine = function(address) {
      address.lines.push({});
    };

    this.addAddress = function() {
      if(!that.model.addresses) {
        that.model.addresses = [];
      }
      that.model.addresses.push({lines: [{}]});
    };

    this.removeEmail = function(index) {
      if(!that.model.emails) { return; }
      that.model.emails.splice(index, 1);
    };

    this.removeNumber = function(index) {
      if(!that.model.numbers) { return; }
      that.model.numbers.splice(index, 1);
    };

    this.removeAddress = function(index) {
      if(!that.model.addresses) { return; }
      that.model.addresses.splice(index, 1);
    };

    this.removeAddressLine = function(address, index) {
      if(address.lines) {
        address.lines.splice(index, 1);
      }
    };

    this.contactSubmitted = false;

    this.cancel = function(form) {
      form.$setPristine();
      that.contactSubmitted = false;
      that.showForm = false;
      that.duplicateEmailsError = false;
      that.model = angular.copy(that.user);
    };

    this.update = function(form) {
      that.contactSubmitted = true;
      that.duplicateEmailsError = false;
      if(form.$valid) {
        that.duplicateEmailsError = false;
        var userId = that.model.id;
        var updateUser = {
          id: userId,
          fname: that.model.fname, // required for person model
          lname: that.model.lname, // required for person model
          emails: angular.copy(that.model.emails),
          numbers: angular.copy(that.model.numbers),
          addresses: angular.copy(that.model.addresses),
        };

        // convert back to simple array of strings
        if(updateUser.addresses) {
          updateUser.addresses = updateUser.addresses.map(function(a) {
            a.lines = a.lines.map(function(line) {
              return line.line;
            });
            return a;
          });
        }

        UserSvc.updateMe(updateUser).$promise
          .then(function() {
            form.$setPristine();
            // in case name changed, reload user
            angular.extend(that.user, updateUser);
            that.showForm = false;
            that.contactSubmitted = false;
            ToastrSvc.success('Contact Information Updated');
          })
          .catch(function(err) {
            var emailErr = 'The specified email is already in use.';
            if(err.data && err.data.errors && err.data.errors.email
            && err.data.errors.email.message === emailErr) {
              that.duplicateEmailsError = true;
            }
          });
      }
    };
  }
}

MeContactCtrl.$inject = ['ToastrSvc', 'UserSvc'];
